var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-error',{attrs:{"error":_vm.error,"type":"Server Error"}})}
var staticRenderFns = []

export { render, staticRenderFns }